import React, { useState } from "react";
import { BlackAndWhite } from "../../../../themes/Colors";
import { BaseButtons } from "../../../../components/atoms";

const HeadersTitleFacilities = ({ onClick, marginTop }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        height: 50,
        display: "flex",
        borderTopColor: BlackAndWhite.primary,
        backgroundColor: BlackAndWhite.primary,
        color: BlackAndWhite.secondary,
        // borderTopLeftRadius: 8,
        // borderTopRightRadius: 8,
        marginTop: marginTop,
      }}
    >
      <div
        style={{
          flex: 0.3,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 15, width: "100%", textAlign: "left" }}>
          {" "}
          STORE NAME
        </div>
      </div>
      <div
        style={{
          flex: 0.15,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 0, width: "100%", textAlign: "left" }}>
          PROVINCE
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 0, width: "100%", textAlign: "left" }}>
          TYPE
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ width: "100%", textAlign: "left" }}>CITY</div>
      </div>
      <div
        style={{
          flex: 0.2,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ width: "100%", textAlign: "left" }}>EMAIL</div>
      </div>
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ width: "100%", textAlign: "left" }}>CELL</div>
      </div>
      <div
        style={{
          flex: 0.2,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ width: "100%", textAlign: "left" }}>OWNER</div>
      </div>

      <div
        style={{
          flex: 0.2,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        ACTIONS
        {/* <div
          onMouseOver={() => setHover(true)}
          onMouseOut={() => setHover(false)}
          onClick={onClick}
          style={{
            backgroundColor: hover
              ? BlackAndWhite.primary
              : BlackAndWhite.secondary,
            borderRadius: 4,
            paddingTop: 7.5,
            paddingBottom: 7.5,
            paddingLeft: 10,
            paddingRight: 15,
            color: hover ? BlackAndWhite.secondary : BlackAndWhite.primary,
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          {hover ? (
            <img
              alt="add"
              src={require("../../../../images/material-icons/addWhite.png")}
              style={{ height: 25, marginRight: 5 }}
            />
          ) : (
            <img
              alt="add"
              src={require("../../../../images/material-icons/addBlack.png")}
              style={{ height: 25, marginRight: 5, opacity: 0.7 }}
            />
          )}
          ADD FACILITIES
        </div> */}
        <div style={{ width: 20 }} />
        {/* <div> Edit users</div>
        <div style={{ width: 20 }} /> */}
      </div>
    </div>
  );
};

export default HeadersTitleFacilities;
